import CandidatePhoto from "./CandidatePhoto";
import { formatPhone } from "../../utils/formatPhone";
import { candidateName } from "../../utils/candidateName";
import CandidateProfileEditor from "./CandidateProfileEditor";
import { message } from "antd";
import DemoDocuments from "./DemoDocuments";
import AbsencesPage from "./AbsencesPage";
import AcomptesPage from "./AcomptesPage";
import { createAcompte } from "../../services/acompteApi";
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, User, Mail, Phone, MapPin, Calendar, Briefcase, Star, Edit, FileText, MessageSquare, Clock, Award, DollarSign, Settings, CheckCircle2, XCircle, AlertCircle, Globe, Target, Activity } from "lucide-react";
import { AddDocumentModal } from "../../components/reusableComponents/AddDocumentModal";
import { AddInterviewModal } from "../../components/reusableComponents/AddInterviewModal";
import { AddCommentModal } from "../../components/reusableComponents/AddCommentModal";
import { AddOpportunityModal } from "../../components/reusableComponents/AddOpportunityModal";
import { AddContractModal } from "../../components/reusableComponents/AddContractModal";
import { AddPayslipModal } from "../../components/reusableComponents/AddPayslipModal";
import { ActivateCandidateModal } from "../../components/reusableComponents/ActivateCandidateModal";
import { AdvancePaymentModal } from "../../components/reusableComponents/AdvancePaymentModal";
import { ReferenceCheckModal } from "../../components/reusableComponents/ReferenceCheckModal";
import { SendToFreelanceModal } from "../../components/reusableComponents/SendToFreelanceModal";
import { SickLeaveModal } from "../../components/reusableComponents/SickLeaveModal";
import { AddAtdModal } from "../../components/reusableComponents/AddAtdModal";
import { PlacementContractModal } from "../../components/reusableComponents/PlacementContractModal";
import { EditProfileModal } from "../../components/reusableComponents/EditProfileModal";
import { AddRatingModal } from "../../components/reusableComponents/AddratingModal";
import DocumentSection from "./DocumentSection";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../axios/AxiosInstance";
import AvailableTable from "./AvailableTable";
import CandidateComment from "./CandidateComment";
import CandidatContract from "./CandidateContract";
import InterviewsSection from "./InterviewsSection";
import OpportunitiesSection from "./OpportunitiesSection";
import RatingsSection from "./RatingsSection";

export const CandidateModal = ({
  isOpen,
  onClose,
  candidate: initialCandidate,
  candidates,
  setCandidates,
  initialTab = "profile",
  demoDocuments = [],
  onDemoRenew = () => {},
}) => {
  // Tabs state
  const [activeTab, setActiveTab] = useState(initialTab);
    const [, setEntretien] = useState([]);
  const [candidate, setCandidate] = useState({ ...initialCandidate });
  const activeCandidate = candidate;

  useEffect(() => {
    if (isOpen) setActiveTab(initialTab);
  }, [isOpen, candidate?._id, initialTab]);

  // Modal states
  const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
  const [isAddInterviewModalOpen, setIsAddInterviewModalOpen] = useState(false);
  const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
  const [isAddOpportunityModalOpen, setIsAddOpportunityModalOpen] =
    useState(false);
  const [isAddRatingModalOpen, setIsAddRatingModalOpen] = useState(false);
  const [isAddContractModalOpen, setIsAddContractModalOpen] = useState(false);
  const [isAddPayslipModalOpen, setIsAddPayslipModalOpen] = useState(false);
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false);
  const [isAdvancePaymentModalOpen, setIsAdvancePaymentModalOpen] =
    useState(false);
  const [isReferenceCheckModalOpen, setIsReferenceCheckModalOpen] =
    useState(false);
  // Données liées aux acomptes
      const [isSendToFreelanceModalOpen, setIsSendToFreelanceModalOpen] =
    useState(false);
  const [isSickLeaveModalOpen, setIsSickLeaveModalOpen] = useState(false);
  const [isAddAtdModalOpen, setIsAddAtdModalOpen] = useState(false);
  const [isPlacementContractModalOpen, setIsPlacementContractModalOpen] =
    useState(false);
  const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);


  const [showNet, setShowNet] = useState(false); // Etat pour basculer entre brut et net

  useEffect(() => {
    if (!candidate?.isDemo) getEntretien();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fonction pour obtenir l'icône de statut
  const getStatusIcon = (status) => {
    switch (status) {
      case 'Disponible':
        return <CheckCircle2 className="w-4 h-4 text-green-600" />;
      case 'En mission':
        return <Clock className="w-4 h-4 text-orange-500" />;
      case 'Indisponible':
        return <XCircle className="w-4 h-4 text-red-500" />;
      default:
        return <AlertCircle className="w-4 h-4 text-gray-500" />;
    }
  };

  // Fonction pour obtenir la couleur de statut
  const getStatusColor = (status) => {
    switch (status) {
      case 'Disponible':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'En mission':
        return 'text-orange-600 bg-orange-50 border-orange-200';
      case 'Indisponible':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  // Formatage de l'expérience
  const formatExperience = (years) => {
    if (years === 0) return "Débutant";
    if (years === 1) return "1 an d'expérience";
    return `${years} ans d'expérience`;
  };

  // Formatage des montants avec gestion des erreurs
  const formatAmount = (amount, decimals = 0) => {
    if (!amount || amount === null || amount === undefined) {
      return "Non renseigné";
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return "Non renseigné";
    }

    return decimals > 0 ? numAmount.toFixed(decimals) : numAmount.toLocaleString();
  };

  const getEntretien = () => {
    axios
      .get(`entretien/${candidate._id}`)
      .then((res) => setEntretien(res.data))
      .catch((e) => {
        console.log(e);
      });
  };

  const handleToggleSalary = () => {
    setShowNet(!showNet); // Inverse la valeur de showNet
  };

  // Formatage de la date au format français
  const formatDate = (dateString) => {
    if (!dateString) return "Non renseigné";

    const date = new Date(dateString);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
      return "Date invalide";
    }

    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  
  
  
  
  /*   const setMonthlySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12).toFixed(2))
      setMonthlySal(value)
      setDailySal((parseFloat(value) / 151.67).toFixed(2))
    }
  }

  const setDailySalary = (value) => {
    if (value === '') {
      setYearlySal('')
      setMonthlySal('')
      setDailySal('')
    } else {
      setYearlySal((parseFloat(value) * 12 * 151.67).toFixed(2))
      setMonthlySal((parseFloat(value) * 151.67).toFixed(2))
      setDailySal(value)
    }
  } */

  // Définition des onglets
  const tabs = [
    { id: "profile", label: "Informations", icon: User },
    { id: "documents", label: "Documents", icon: FileText },
    { id: "availability", label: "Disponibilités", icon: Clock },
    { id: "interviews", label: "Entretiens", icon: Calendar },
    { id: "opportunities", label: "Candidature", icon: Target },
    { id: "contracts", label: "Contrats", icon: Briefcase },
    { id: "absences", label: "Absences", icon: Activity },
    { id: "advances", label: "Acomptes", icon: DollarSign },
    { id: "comments", label: "Commentaire", icon: MessageSquare },
    { id: "ratings", label: "Évaluations", icon: Star },
  ];

  if (!candidate) {
    return null;
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[90vh] flex flex-col overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <header className="border-b border-slate-200 bg-white px-5 py-4 sm:px-8">
              <div className="flex items-start justify-between gap-4">
                <div className="flex min-w-0 items-center gap-4"><CandidatePhoto key={candidate._id} candidate={candidate} onUpdated={updated => {setCandidate(updated);setCandidates?.(current => current.map(row => row._id === updated._id ? updated : row));}} /><div className="min-w-0"><h2 className="text-2xl font-bold text-slate-900">{candidateName(candidate)}</h2><span className="ml-2 inline-block rounded-full bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700">{candidate.pld != null && String(candidate.pld).trim() !== "" ? "Intérimaire" : "Candidat"}</span><p className="mt-1 text-sm text-slate-500">{candidate.jobTitle || "Fiche candidat"}{candidate.pld ? ` · N° ${candidate.pld}` : ""}{candidate.isDemo ? " · Démonstration" : ""}</p><div className="mt-2 flex flex-wrap gap-3 text-xs text-blue-800">{candidate.phone && <a href={`tel:${candidate.phone}`} className="inline-flex items-center gap-1"><Phone size={13} />{formatPhone(candidate.phone)}</a>}{candidate.email && <a href={`mailto:${candidate.email}`} className="inline-flex items-center gap-1"><Mail size={13} />{candidate.email}</a>}</div></div></div>
                <button type="button" aria-label="Fermer la fiche candidat" onClick={onClose} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"><X size={22} /></button>
              </div>
            </header>
            {/* Navigation par onglets */}
            <div className="bg-slate-50 border-b border-slate-200">
              <div className="px-3">
                <div className="flex flex-nowrap overflow-x-auto">
                  {tabs.filter(tab => !candidate.isDemo || ["profile", "documents"].includes(tab.id)).map((tab) => {
                    const IconComponent = tab.icon;
                    return (
                      <motion.button
                        key={tab.id}
                        className={`flex shrink-0 items-center space-x-1.5 px-2 py-3 text-xs font-medium border-b-2 transition-all duration-200 whitespace-nowrap ${
                          activeTab === tab.id
                            ? "text-blue-600 border-blue-600 bg-white"
                            : "text-slate-600 border-transparent hover:text-slate-900 hover:border-slate-300"
                        }`}
                        onClick={() => setActiveTab(tab.id)}
                        whileHover={{ y: -1 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <IconComponent className="w-4 h-4" />
                        <span>{tab.label}</span>
                      </motion.button>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Contenu des onglets */}
            <div className="flex-1 overflow-y-auto">
              <div className="p-4 sm:p-6">


                <AnimatePresence mode="wait">
                  {activeTab === "absences" && <AbsencesPage key={`absences-${candidate._id}`} candidate={candidate} embedded />}
                  {activeTab === "advances" && <AcomptesPage key={`acomptes-${candidate._id}`} candidateId={candidate._id} candidate={candidate} embedded />}
                  {activeTab === "profile" && <CandidateProfileEditor key={candidate._id} candidate={candidate} onUpdated={updated => {setCandidate(updated);setCandidates?.(current => current.map(row => row._id === updated._id ? updated : row));}} />}

                  {activeTab === "documents" && (
                    <motion.div
                      key="documents"
                    >
                      {candidate.isDemo ? <DemoDocuments documents={demoDocuments} onRenew={onDemoRenew} /> : <DocumentSection candidate={candidate} />}
                    </motion.div>
                  )}

                  {/* Onglet Disponibilité */}
                  {activeTab === "availability" && (
                    <motion.div
                      key="availability"
                    >
                      <AvailableTable key={candidate._id} candidate={candidate} setCandidates={setCandidates} onUpdated={setCandidate} />
                    </motion.div>
                  )}

                  {/* Onglet Commentaires */}
                  {activeTab === "comments" && (
                    <motion.div
                      key="comments"
                    >
                      <CandidateComment candidate={candidate} candidates={candidates} setCandidates={setCandidates} />
                    </motion.div>
                  )}

                  {/* Onglet Contrats */}
                  {activeTab === "contracts" && (
                    <motion.div
                      key="contracts"
                    >
                      <CandidatContract candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Entretiens */}
                  {activeTab === "interviews" && (
                    <motion.div
                      key="interviews"
                    >
                      <InterviewsSection candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Opportunités */}
                  {activeTab === "opportunities" && (
                    <motion.div
                      key="opportunities"
                    >
                      <OpportunitiesSection candidateId={candidate._id} candidate={candidate} />
                    </motion.div>
                  )}

                  {/* Onglet Paie */}
                  {activeTab === "ratings" && (
                    <motion.div
                      key="ratings"
                    >
                      <RatingsSection candidateId={candidate._id} />
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>

            {/* Modals */}
            <AddDocumentModal
              isOpen={isAddDocumentModalOpen}
              onClose={() => setIsAddDocumentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Document ajouté:", data);
                setIsAddDocumentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddInterviewModal
              isOpen={isAddInterviewModalOpen}
              onClose={() => setIsAddInterviewModalOpen(false)}
              onSubmit={(data) => {
                console.log("Entretien ajouté:", data);
                setIsAddInterviewModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddCommentModal
              isOpen={isAddCommentModalOpen}
              onClose={() => setIsAddCommentModalOpen(false)}
              onSubmit={(data) => {
                console.log("Commentaire ajouté:", data);
                setIsAddCommentModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddOpportunityModal
              isOpen={isAddOpportunityModalOpen}
              onClose={() => setIsAddOpportunityModalOpen(false)}
              onSubmit={(data) => {
                console.log("Opportunité ajoutée:", data);
                setIsAddOpportunityModalOpen(false);
              }}
              candidateId={candidate._id}
            />

            <AddContractModal
              isOpen={isAddContractModalOpen}
              onClose={() => setIsAddContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat ajouté:", data);
                setIsAddContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddPayslipModal
              isOpen={isAddPayslipModalOpen}
              onClose={() => setIsAddPayslipModalOpen(false)}
              onSubmit={(data) => {
                console.log("Fiche de paie ajoutée:", data);
                setIsAddPayslipModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <ActivateCandidateModal
              isOpen={isActivateModalOpen}
              onClose={() => setIsActivateModalOpen(false)}
              onSubmit={(data) => {
                console.log("Candidat activé:", data);
                setIsActivateModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AdvancePaymentModal hidePaymentMethod isOpen={isAdvancePaymentModalOpen} onClose={() => setIsAdvancePaymentModalOpen(false)} candidateId={candidate._id} onSave={async data => {
              if (!Number.isFinite(Number(data.amount)) || Number(data.amount) <= 0) {message.error("Indiquez un montant positif.");return;}
              try {
                await createAcompte({candidateId: candidate._id, amount: data.amount, paymentDate: data.paymentDate, reason: data.reason});
                setIsAdvancePaymentModalOpen(false);setActiveTab("advances");message.success("Demande transmise à l’agence.");
              } catch (error) {message.error(error.response?.data?.message || "Impossible d’enregistrer la demande.");}
            }} />

            <ReferenceCheckModal
              isOpen={isReferenceCheckModalOpen}
              onClose={() => setIsReferenceCheckModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrôle de référence:", data);
                setIsReferenceCheckModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SendToFreelanceModal
              isOpen={isSendToFreelanceModalOpen}
              onClose={() => setIsSendToFreelanceModalOpen(false)}
              onSubmit={(data) => {
                console.log("Envoyé à freelance:", data);
                setIsSendToFreelanceModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <SickLeaveModal
              isOpen={isSickLeaveModalOpen}
              onClose={() => setIsSickLeaveModalOpen(false)}
              onSubmit={(data) => {
                console.log("Arrêt maladie ajouté:", data);
                setIsSickLeaveModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <AddAtdModal
              isOpen={isAddAtdModalOpen}
              onClose={() => setIsAddAtdModalOpen(false)}
              onSubmit={(data) => {
                console.log("ATD ajouté:", data);
                setIsAddAtdModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <PlacementContractModal
              isOpen={isPlacementContractModalOpen}
              onClose={() => setIsPlacementContractModalOpen(false)}
              onSubmit={(data) => {
                console.log("Contrat de placement:", data);
                setIsPlacementContractModalOpen(false);
              }}
              candidateId={candidate.id}
            />

            <EditProfileModal
              isOpen={isEditProfileModalOpen}
              onClose={() => setIsEditProfileModalOpen(false)}
              onSubmit={(data) => {
                console.log("Profil modifié:", data);
                setIsEditProfileModalOpen(false);
              }}
              candidate={candidate}
            />

            <AddRatingModal
              isOpen={isAddRatingModalOpen}
              onClose={() => setIsAddRatingModalOpen(false)}
              onSubmit={(data) => {
                console.log("Notation ajoutée:", data);
                setIsAddRatingModalOpen(false);
              }}
              candidateId={candidate.id}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};



 
